import Prism from 'prismjs';

Prism.manual = true;

export function wrapLines(
  code: string,
  opts: {
    class?: string;
  } = {}
) {
  return code
    .split('\n')
    .map(line => `<span class="${opts.class || 'line'}">${line}</span>`)
    .join('\n');
}

export function highlightSyntax(
  code: string,
  language: Parameters<typeof Prism.highlight>[2] = 'sql'
) {
  const highlighted = Prism.highlight(
    code,
    Prism.languages[language],
    language
  );

  return wrapLines(highlighted);
}
